<template>
    <section>
        <div v-if="!displayErrors.$clean" class="alert alert-danger mt-15" role="alert">
            <div v-for="(error, index) in displayErrors" v-bind:key="index">
                <span v-if="error">
                    <span v-if="error.$name && error.$error[0].message  ">
                        {{ error.$error[0].message }}
                    </span>
                    <span v-else-if="error.$error">
                        {{error.$error}}
                    </span>
                </span>
                <span v-else>
                    A general system error occurred
                </span>
            </div>
        </div>
        <div v-if="success && success.show" class="alert alert-success mt-15" role="alert">
            {{success.message}}
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Object|Error,
                $clean: true
            },
        },
        computed:{
            displayErrors: function() {
                return this.errors;
            }
        },
        data() {
            return {
                success: {
                    show: false,
                    message: 'Success'
                },
            }
        },
        methods: {
            showSuccess(message) {
                this.displayErrors ={
                    type: Object|Error,
                    $clean: true
                };
                this.success.show = true;
                this.success.message = message;
                let self = this;
                setTimeout(function(){
                    self.success.show = false;
                }, 3000);

            }
        },
        mounted() {
        }
    }
</script>
